export default "__VITE_ASSET__28c0d97a__"